export default "__VITE_ASSET__DvkngbGS__"